{
  "id": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "isNotRenderable": true,
    },
  },
  "transfer_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Transfer Date",
      "width": 125,
      "isShownByDefault": true,
    },
  },
  "wellbore_uwi_list": {
    "source": "regulator",
    "domainType": "object",
    "ui": {
      "label": "UWIs",
      "isNotRenderable": true,
    },
  },
  "from_company": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "From",
      "isShownByDefault": true,
    },
  },
  "to_company": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "To",
      "isShownByDefault": true,
    },
  },
  "province": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Province",
      "width": 60,
      "isShownByDefault": true,
    },
  },
  "wellbore_count": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Wellbores",
      "isShownByDefault": true,
    },
  },
  "license_count": {
    "source": "regulator",
    "domainType": "number",
    "ui": {
      "label": "Licence Count",
      "isShownByDefault": true,
    },
  },
  "oil_vol_per_day": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d",
    },
    "ui": {
      "label": "Oil",
      "width": 175,
      "isShownByDefault": true,
    },
  },
  "gas_vol_per_day": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "boe/d",
    },
    "ui": {
      "label": "Gas",
      "width": 75,
      "isShownByDefault": true,
    },
  },
  "condensate_bbl_per_day": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d",
    },
    "ui": {
      "label": "Condensate",
      "width": 175,
      "isShownByDefault": true,
    },
  },
  "ngl_bbl_per_day": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "bbl/d",
    },
    "ui": {
      "label": "NGL",
      "width": 175,
      "isShownByDefault": true,
    },
  },
  "total_boe_production": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "boe/d",
    },
    "ui": {
      "label": "Total Production",
      "isShownByDefault": true,
    },
  },
  "prod_month_considered": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Prod Month Considered",
      "width": 250,
      "isShownByDefault": true,
      "isNotSortable": true,
    },
  },
}
